let params = {};
const pathname = document.location.pathname;

if (document.location.toString().indexOf('?') !== -1) {
    const query = document.location
        .toString()
        .replace(/^.*?\?/, '')
        .replace(/#.*$/, '')
        .split('&');

    for (let i = 0, l = query.length; i < l; i++) {
        const aux = decodeURIComponent(query[i]).split('=');
        params[aux[0]] = aux[1];
    }
}

function getParameterByName(name) {
    return params[name];
}

function getAllParameters() {
    return params;
}

function setParameter(key, value) {

    if (value === '' || value === null || value === undefined) {
        delete params[key];
    } else {
        params[key] = value;
    }
    return api;
}
function clearAllParams(){
    params = {};
}

function updateURL() {
    let str = '';
    for (const key in params) {
        if (str !== '') {
            str += '&';
        }
        str += key + '=' + encodeURIComponent(params[key]);
    }
    window.history.pushState({}, '', pathname + '?' + str);
    return api;
}

function replaceURL() {
    let str = '';
    for (const key in params) {
        if (str !== '') {
            str += '&';
        }
        str += key + '=' + encodeURIComponent(params[key]);
    }
    window.history.replaceState({}, '', pathname + '?' + str);
    return api;
}

function setHash(value){
    if (history.replaceState) {
        history.replaceState(null, null, '#' + value);
    } else {
        location.hash = '#' + value;
    }
}

function getHash(){
    if (window.location.hash) {
        return window.location.hash.replace('#', '');
    }
    return undefined;
}

function setParamsAsString(string){
    const mark = string.indexOf('?') !== -1 ? '' : '?';
    window.history.replaceState({}, '', pathname + mark + string);
}

// public
const api = {
    setParameter,
    getParameterByName,
    getAllParameters,
    updateURL,
    clearAllParams,
    replaceURL,
    setHash,
    getHash,
    setParamsAsString
};

export default api;
